require('./bootstrap');
require('bootstrap-select/js/bootstrap-select');
require('startbootstrap-sb-admin-2/js/sb-admin-2');
require('./admin/ajax-form');
require('./admin/scripts');
require('./admin/destroy-confirmation');
require('./admin/contract-invoice-block');
require('./admin/contract-payments');
require('./admin/contract-position-lock-confirmation');
require('./admin/contract-quantity-of-missions-alert');
require('./admin/print-confirmation');
require('./admin/offer-position-article-table');
require('./admin/offer-position-table');
require('./admin/pikaday_config');
require('./admin/table-sort');
require('./admin/contract-specialist-fee');
require('./admin/invoice-alert');
require('./admin/double-clickable')
require('./admin/email-attachments');
require('./admin/value-takeover');
require('./admin/invoice-payment-form');
require('./admin/livewire-modals');
require('./admin/dragula');
require('./admin/appointmentTable');
require('./admin/safety-question');
require('../../vendor/mintellity/laravel-tabbed-session/resources/js/tabbedSession')('browserTabId');
require('./admin/counterCalculation');
require('./admin/positionsTable-Livewire-init');
require('./admin/invoiceScripts');
require('./admin/swal');
require('./admin/table-fixed');
require('./admin/readonly-fieldsets');
require('livewire-sortable');
